import React from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
} from '@coreui/react-pro'

type TProps = {
  isOpen: boolean
  onSubmit: () => void
  onCancel: () => void
  title?: React.ReactNode
  message?: React.ReactNode
}
export const ConfirmModal: React.FC<TProps> = ({
  isOpen,
  onSubmit,
  onCancel,
  title = 'Confirm',
  message = 'Are you sure?',
}) => {
  return (
    <CModal visible={isOpen} onClose={onCancel}>
      <CModalHeader>{title}</CModalHeader>
      <CModalBody>{message}</CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onCancel}>
          Cancel
        </CButton>
        <CButton color="primary" className="px-4" onClick={onSubmit}>
          Ok
        </CButton>
      </CModalFooter>
    </CModal>
  )
}
